import React from 'react';
import { AppFontIcon, AppText } from '@frontend-modules/ui-kit';
import { useWindowResize } from 'hooks';

import { ETagBackColor, ETagIcons, ETagLabel, ETagMainColor } from './OnlineLessonTag.config';
import { TOnlineLessonTagProps } from './OnlineLessonTag.types';

import './OnlineLessonTag.style.scss';
export const OnlineLessonTag: React.FC<TOnlineLessonTagProps> = (props) => {
    const { type, text, isIconView = false } = props;
    const isMobile = useWindowResize();

    const label = type !== 'course_group_tag' ? ETagLabel[type] : text;

    if (isIconView) {
        return <AppFontIcon icon={ETagIcons[type]} color={ETagMainColor[type]} size={20} />;
    }
    if (label) {
        return (
            <div className={`online-lesson-tag`} style={{ backgroundColor: ETagBackColor[type] }}>
                <AppText
                    text={isMobile ? label.split(' ')[0] : label}
                    color={ETagMainColor[type]}
                    textStyle={'DesktopH4'}
                />
            </div>
        );
    }

    return null;
};
